import React, { useState } from 'react';
import {
  Grid,
  Typography,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
} from '@mui/material';
import { useApiSend } from '../../utils/httpClient';
import { getForgotPassword } from '../../endpoints/login';
import AlertItem from '../../Components/AlertItem';
import { Image } from 'mui-image';
import logo from './../../assets/PEO_InformalLogo_Color.png';
import { ArrowBack, Email } from '@mui/icons-material';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [showAlert, setShowAlert] = useState(false);
  const [error, setError] = useState(null);

  const { mutate } = useApiSend(
    getForgotPassword,
    (data) => {
      setShowAlert(true);
    },
    (error) => {
      // Handle error response
      setError('Error sending password reset link, please try again later.');
    }
  );

  return (
    <Grid
      container
      direction={'column'}
      alignItems="center"
      sx={{ verticalAlign: 'middle' }}
    >
      <Grid item xs={12} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader
            title="Forgot Password"
            subheader="Please enter your email to reset your password"
            sx={{ p: 1 }}
          />
          <CardContent sx={{ p: 1 }}>
            <Grid
              container
              spacing={2}
              direction={'column'}
              alignItems="center"
              sx={{ verticalAlign: 'middle' }}
            >
              <Grid
                item
                xs={12}
                textAlign={'center'}
                justifyContent={'center'}
                alignItems={'center'}
              >
                <Image
                  src={logo}
                  alt="Logo"
                  sx={{ maxWidth: '300px' }}
                  width={'40vw'}
                />
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  Enter your email address below and we will send you a link to
                  reset your password.
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} paddingTop={2}>
              <TextField
                label="Email"
                variant="outlined"
                fullWidth
                value={email}
                size={'small'}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} paddingTop={2} textAlign={'center'}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => mutate({ email })}
                size="small"
              >
                <Email style={{ marginRight: 8, fontSize: 16 }} />
                Send Reset Link
              </Button>
            </Grid>
            <Grid item xs={12} paddingTop={2} textAlign={'center'}>
              <Button
                variant="contained"
                color="primary"
                onClick={() => (window.location.href = '/login')}
                size="small"
              >
                <ArrowBack style={{ marginRight: 8, fontSize: 16 }} />
                Back to Login
              </Button>
            </Grid>
            <Grid item xs={12} paddingTop={2}>
              {error && (
                <AlertItem
                  severity="error"
                  description={error}
                  onClose={() => setError(null)}
                />
              )}
              {showAlert && (
                <AlertItem
                  severity="success"
                  description={`If you have an account under ${email}, you will receive an email with instructions to reset your password.`}
                  onClose={() => setShowAlert(false)}
                  keepOpen={true}
                />
              )}
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
export default ForgotPassword;
